// src/features/users/components/UserStatusBadge.tsx
import type { User } from '../types/user.types';

export interface UserStatusBadgeProps {
  status: User['status'];
}

const STATUS_LABEL: Record<User['status'], string> = {
  active: 'فعال',
  suspended: 'تعلیق شده',
};

const STATUS_COLOR_VAR: Record<User['status'], string> = {
  active: 'var(--vania-accent-teal, #2fd6a7)',
  suspended: 'var(--vania-accent-rose, #ff6b81)',
};

/**
 * Small pill badge mapping a user's raw status to its Persian label +
 * accent color. Same status-badge shape used by
 * customers/components/CustomerStatusBadge.tsx and
 * tenants/components/TenantStatusBadge.tsx (label map + color-var map
 * keyed by the union type) — kept local to this feature since the
 * union (active/suspended/pending) is user-specific.
 */
export function UserStatusBadge({ status }: UserStatusBadgeProps) {
  const color = STATUS_COLOR_VAR[status];

  return (
    <span className="vania-user-status-badge" style={{ color, borderColor: color }}>
      <span aria-hidden className="vania-user-status-dot" style={{ backgroundColor: color }} />
      {STATUS_LABEL[status]}
    </span>
  );
}
